<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <DataTable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
        <v-row dense>
          <v-col cols="12" sm="6">
            <ViewDetails :object="object" type="Solicitud"/>
          </v-col>
          <v-col cols="12" sm="6">
            <ViewDetails :object="object" type="Movements"/>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <MesaAyudaTicketsDialog v-if="get_dialogMain.dialog" :model="object"/>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MesaAyudaTicketsDialog from '@/components/dialog/mesaayuda/MesaAyudaTicketsDialog'
import ViewDetails from '@/components/ViewDetails'
import tableMain from '@/components/dataTableMain'
export default {
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Solicitante', value: 'descripcion.solicitante', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Tipo Atencion', value: 'tipo_servicio.nombre', align: 'center', class: 'black--text' },
          { text: 'Tipo Actividad', value: 'Actividad', align: 'center', class: 'black--text' },
          { text: 'Estatus', value: 'Status', align: 'center', class: 'black--text' },
          { text: 'Programado', value: 'Programado', align: 'center', class: 'black--text' },
          { text: '', value: 'Actions' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    item: {}
  }),
  components: {
    MesaAyudaTicketsDialog,
    DataTable: tableMain,
    ViewDetails
  },
  mounted () {
    this.getDataUrl('ma.list-servicios-assigned')
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('ma.list-servicios-assigned')
    },

    tableAction (item) {
      this[item.action](item)
    },
    toAttend (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'attend', with: 600, title: 'Atender Servivio' })
    },
    toFinish (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'finish', with: 600, title: 'Finalizar Servivio' })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('ma.list-servicios-assigned')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        if (vals.length > 0) {
          this.table.modelMain = []
          this.table.modelMain.push(vals[0])
        }
        this.table.header.loading = false
      }
    }
  }
}
</script>

<style>
</style>
